import React from 'react';
import Layout from '@/sections/Layout';

import Header from '@/sections/pages/Blog/Header';
import HeadNews from '@/sections/pages/Blog/HeadNews';
import Aside from '@/sections/pages/Blog/Aside';
import News from '@/sections/pages/Blog/News';
import Join from '@/sections/common/Join';

import '@/sections/pages/Blog/styles.scss';

import CATEGORIES_LIST from '@/mocks/categories';
import NEWS_LIST from '@/mocks/news';

const Blog = () => {
  const HEADER_DATA = {
    subtitle: 'Blog',
    title: 'Useful resources & our updates',
  };

  const HEAD_NEWS = {
    subtitle: 'Future of retail',
    title: 'Biometric technology means big things for retail and hospitality',
    imgSrc: '/images/temp/blog/head-news.jpg',
    date: 'September 13',
  };

  const ASIDE_DATA = {
    categoriesCommon: CATEGORIES_LIST.common,
    categoriesPopular: CATEGORIES_LIST.popular,
  };

  const NEWS_DATA = {
    title: 'Recent news',
    list: NEWS_LIST,
  };

  return (
    <Layout
      currentPageClass={'cr-blog-page'}
      headerClass={'cr-blog-header'}
      mainClass={'cr-blog-main'}
      footerClass={'cr-blog-footer'}
    >
      {(commonData) => (
        <>
          <div className="cr-wrap cr-blog-main-inner">
            <section className="cr-blog-main-inner__header">
              <Header data={HEADER_DATA} />
            </section>

            <section className="cr-blog-main-inner__head-news">
              <HeadNews data={HEAD_NEWS} />
            </section>

            <aside className="cr-blog-main-inner__aside">
              <Aside data={ASIDE_DATA} />
            </aside>

            <section className="cr-blog-main-inner__news">
              <News data={NEWS_DATA} />
            </section>
          </div>

          <div className="cr-blog-main-inner__join">
            <Join />
          </div>
        </>
      )}
    </Layout>
  );
};

export default Blog;
